import { Modal } from 'antd';
import React, { useState } from 'react';
import DeleteWarningModalWithAction from '../../../../components/Common/DeleteWarningModalWithAction';
import { addPromoCode } from '../../../../services/promoCodeService';
import PromoCodeForm from './PromoCodeForm';

const PromoCodeAdd = ({
  isOpen,
  toggle,
  status,
  setStatus,
  courses,
  courseOffers
}) => {
  const initialValues = {
    type: 'coupon',
    revenueSplitType: 'creator_funded',
    revenueSplitSubType: 'default',
    excludeEnrolment: false,
    isCorporate: false,
    corporatePercent: 0,
    discountValue: 0,
    discountType: 'percent_off',
    isActive: false,
    allowInAllCountries: false
  };
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(
    false
  );
  const [promoFormValues, setpromoFormValues] = useState(false);

  const onConfirm = async () => {
    let payload = {
      ...promoFormValues,
      startDate: promoFormValues.startDate.utc().format(),
      endDate: promoFormValues.endDate.utc().format()
    };

    if (payload.type === 'giftCard') {
      const referrerId = JSON.parse(payload.referrerId);
      const assignedTo = JSON.parse(payload.assignedTo[0]);
      payload.metadata = {
        giftedBy: {
          name: referrerId.firstName + ' ' + referrerId.lastName,
          email: referrerId.email,
          phoneNumber: referrerId.phoneNumber,
          country: referrerId.countryId
        },
        assignedTo: {
          name: assignedTo.firstName + ' ' + assignedTo.lastName,
          email: assignedTo.email,
          phoneNumber: assignedTo.phoneNumber,
          country: assignedTo.countryId
        }
      };
    } else if (payload.type === 'referral') {
      const referrerId = JSON.parse(payload.referrerId);
      payload.metadata = {
        referrerId: referrerId._id
      };
    }

    if (!payload.assignedTo) {
      payload.assignedTo = [];
    } else {
      const assignedTo = payload.assignedTo;
      payload.assignedTo = assignedTo.map(
        (user) => JSON.parse(user).email
      );
    }

    delete payload.referrerId;
    if (payload.discountType === 'amount_off') {
      payload.discountValue = parseInt(payload.discountValue * 100);
    }
    payload.countryWiseDiscounts.forEach((countryDiscount) => {
      countryDiscount.value =
        payload.discountType === 'amount_off'
          ? countryDiscount.value * 100
          : countryDiscount.value;
    });

    await addPromoCode(payload)
      .then((response) => {
        setStatus({
          type: 'SUCCESS',
          message: 'Promo code added successfully!'
        });
      })
      .catch((error) => {
        alert('Posting data to the backend failed!');
        if (error?.response?.data?.message)
          setStatus({
            type: 'ERROR',
            message: error.response.data.message
          });
        else
          setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  const onSubmit = async (values) => {
    setIsConfirmModalVisible(true);
    setpromoFormValues(values);
  };

  return (
    <Modal
      title={`Add Promo Code`}
      visible={isOpen}
      onCancel={() => toggle()}
      footer={null}>
      <PromoCodeForm
        type="Add"
        initialValues={initialValues}
        onSubmit={onSubmit}
        status={status}
        visible={isOpen}
        setStatus={setStatus}
        courses={courses}
        courseOffers={courseOffers}
        maxValue={100}
      />
      <DeleteWarningModalWithAction
        isVisible={isConfirmModalVisible}
        setIsVisible={setIsConfirmModalVisible}
        action={onConfirm}
        question={`Are You Sure You Want To Create ${
          promoFormValues.isCorporate ? 'Corporate ' : ''
        } ${promoFormValues.type} ${promoFormValues.code} with ${
          promoFormValues.discountValue
        } ${
          promoFormValues.discountType === 'percent_off' ? '%' : 'USD'
        } off`}
        buttonLabel="Confirm"
      />
    </Modal>
  );
};

export default PromoCodeAdd;
